import { useCallback, useState } from 'react';
import { useBrandPricingSupplierQuery } from 'api';
import { useParams } from 'react-router-dom';

export const usePricing = () => {
  const [updateModalState, setUpdateModalState] = useState<boolean>(false);
  const [drawerState, setDrawerState] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data = {} } = useBrandPricingSupplierQuery({ brandId: id });

  const onUpdateModalStateChange = useCallback(() => setUpdateModalState((prevState) => !prevState), []);

  const onExpand = useCallback(() => {
    setDrawerState((prevState) => !prevState);
  }, []);
  return {
    updateModalState,
    onUpdateModalStateChange,
    onExpand,
    dataToEdit: data?.pricingRulesResponse || {},
    drawerState,
  };
};
